export default "__VITE_ASSET__BknAyRZu__"